import * as React from 'react';
import { Trans } from 'react-i18next';
import { useSelector } from 'react-redux';
import { Box } from '@lightspeed/flame/Core';
import { IconQrcode } from '@lightspeed/flame/Icon/Qrcode';
import { Text } from '@lightspeed/flame/Text';

import { getAblyCustomerConnectionStatus } from '~/renderer/store/connection/selectors';
import { isCustomerCFD } from '~/renderer/utils';

const ScreenUnavailable: React.FC = () => {
  const ablyCustomerConnectionStatus = useSelector(getAblyCustomerConnectionStatus);
  const isUnavailable =
    isCustomerCFD &&
    !window.location.search.includes('status=') &&
    ablyCustomerConnectionStatus === 'unavailable';

  return isUnavailable ? (
    <Box textAlign="center">
      <IconQrcode size="6rem" color="blue-300" />
      <br />
      <Text mt={4} color="white" size="large">
        <Trans i18nKey="hub.cfd.registerCustomer.unavailable">
          <br />
        </Trans>
      </Text>
    </Box>
  ) : null;
};

export default ScreenUnavailable;
